import {
    FETCH_DELETION_REQUESTS,
    PROCESS_DELETION_REQUEST,
    DELETION_REQUESTS_LOADING,
} from "../constants/actionTypes";
import * as api from "../api/index";
import { toast } from "react-toastify";

/**
 * Fetch all account deletion requests (Super Admin only).
 * Populates state.deletionRequests.requests
 */
export const fetchDeletionRequests = () => async (dispatch) => {
    try {
        dispatch({ type: DELETION_REQUESTS_LOADING });
        const { data } = await api.apiFetchDeletionRequests();
        dispatch({ type: FETCH_DELETION_REQUESTS, payload: data.requests });
    } catch (error) {
        console.error("[DeletionRequests]", error);
        toast.error(
            error?.response?.data?.message || "Failed to load deletion requests"
        );
    }
};

/**
 * Process a deletion request.
 * @param {string} requestId - AccountDeletionRequest._id
 * @param {"deactivate"|"delete"} action - What to do with the user record
 * @param {string} adminId - The admin performing the action
 */
export const processDeletionRequest =
    (requestId, action, adminId) => async (dispatch) => {
        try {
            const { data } = await api.apiProcessDeletionRequest(
                requestId,
                action,
                adminId
            );
            dispatch({ type: PROCESS_DELETION_REQUEST, payload: requestId });
            toast.success(data.message || "Request processed successfully");
        } catch (error) {
            console.error("[DeletionRequests] process error:", error);
            toast.error(
                error?.response?.data?.message || "Failed to process request"
            );
            throw error;
        }
    };
